import { createApp } from 'vue'
import './assets/main.css'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import {definePreset} from "@primeuix/themes";
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import 'maplibre-gl/dist/maplibre-gl.css';
import * as Sentry from "@sentry/vue";

// Инициализация Sentry (только если DSN указан)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const sentryEnvironment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';

if (sentryDsn) {
    Sentry.init({
        app: createApp(App),
        dsn: sentryDsn,
        environment: sentryEnvironment,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],

        // Performance Monitoring
        tracesSampleRate: sentryEnvironment === 'production' ? 0.1 : 1.0, // 10% на проде, 100% на dev
        tracePropagationTargets: ["localhost", /^https:\/\/yourapi\.com\/api/],

        // Session Replay
        replaysSessionSampleRate: sentryEnvironment === 'production' ? 0.01 : 0.1, // 1% на проде, 10% на dev
        replaysOnErrorSampleRate: sentryEnvironment === 'production' ? 1.0 : 1.0, // 100% при ошибках
    });
}

createApp(App)
    .use(createPinia())
    .use(router)
    .use(PrimeVue, {
        theme: {
            preset: definePreset ( Aura,{
                semantic: {
                    primary: {
                        50: '{slate.50}',
                        100: '{slate.100}',
                        200: '{slate.200}',
                        300: '{slate.300}',
                        400: '{slate.400}',
                        500: '{slate.500}',
                        600: '{slate.600}',
                        700: '{slate.700}',
                        800: '{slate.800}',
                        900: '{slate.900}',
                        950: '{slate.950}'
                    }
                }
                }
            ),
            options: {
                prefix: 'p',
                cssLayer: {
                    name: 'primevue',
                    order: 'theme, base'
                }
            }
        }
    })
    .use(ToastService)
    .use(ConfirmationService)
    .directive('tooltip', Tooltip)
    .mount('#app')
